import { isValid } from 'date-fns';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);

      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}

var TokenType;

(function (TokenType) {
  TokenType[TokenType["Number"] = 0] = "Number";
  TokenType[TokenType["Identifier"] = 1] = "Identifier";
  TokenType[TokenType["DynamicIdentifier"] = 2] = "DynamicIdentifier";
  TokenType[TokenType["String"] = 3] = "String";
  TokenType[TokenType["Date"] = 4] = "Date";
  TokenType[TokenType["TimeSpan"] = 5] = "TimeSpan";
  TokenType[TokenType["Terminal"] = 6] = "Terminal";
  TokenType[TokenType["EndOfString"] = 7] = "EndOfString";
  TokenType[TokenType["Null"] = 8] = "Null";
  TokenType[TokenType["ArIn"] = 9] = "ArIn";
  TokenType[TokenType["ArEq"] = 10] = "ArEq";
  TokenType[TokenType["ArNotEq"] = 11] = "ArNotEq";
  TokenType[TokenType["ArGr"] = 12] = "ArGr";
  TokenType[TokenType["ArGre"] = 13] = "ArGre";
  TokenType[TokenType["ArLs"] = 14] = "ArLs";
  TokenType[TokenType["ArLse"] = 15] = "ArLse";
  TokenType[TokenType["BoolNot"] = 16] = "BoolNot";
  TokenType[TokenType["BoolAnd"] = 17] = "BoolAnd";
  TokenType[TokenType["BoolOr"] = 18] = "BoolOr";
  TokenType[TokenType["ArPlus"] = 19] = "ArPlus";
  TokenType[TokenType["ArMinus"] = 20] = "ArMinus";
  TokenType[TokenType["ArMul"] = 21] = "ArMul";
  TokenType[TokenType["ArDiv"] = 22] = "ArDiv";
  TokenType[TokenType["ExprOpen"] = 23] = "ExprOpen";
  TokenType[TokenType["ExprClose"] = 24] = "ExprClose";
  TokenType[TokenType["ArrayOpen"] = 25] = "ArrayOpen";
  TokenType[TokenType["ArrayClose"] = 26] = "ArrayClose";
  TokenType[TokenType["Separator"] = 27] = "Separator";
  TokenType[TokenType["Function"] = 28] = "Function";
  TokenType[TokenType["Between"] = 29] = "Between";
  TokenType[TokenType["Outside"] = 30] = "Outside";
})(TokenType || (TokenType = {}));

const DEFAULT_TOKEN_POSITION = {
  start: 0,
  end: 0
};
let Token = /*#__PURE__*/_createClass(function Token(type, value, position) {
  if (position === void 0) {
    position = DEFAULT_TOKEN_POSITION;
  }

  _classCallCheck(this, Token);

  this.type = type;
  this.value = value;
  this.position = position;
});

let ExpressionNode = /*#__PURE__*/function () {
  function ExpressionNode(token, left, right) {
    if (left === void 0) {
      left = null;
    }

    if (right === void 0) {
      right = null;
    }

    _classCallCheck(this, ExpressionNode);

    this.token = token;
    this.left = left;
    this.right = right;
  } // @ts-ignore


  _createClass(ExpressionNode, [{
    key: "accept",
    value: function accept(visitor) {
      // TODO find way to resolve any...
      // @ts-ignore
      return visitor.visit(this);
    }
  }]);

  return ExpressionNode;
}();
let ValueNode = /*#__PURE__*/function (_ExpressionNode) {
  _inherits(ValueNode, _ExpressionNode);

  var _super = /*#__PURE__*/_createSuper(ValueNode);

  function ValueNode() {
    _classCallCheck(this, ValueNode);

    return _super.apply(this, arguments);
  }

  _createClass(ValueNode, null, [{
    key: "is",
    value: function is(token) {
      return ValueNode.TOKENS.includes(token.type);
    }
  }]);

  return ValueNode;
}(ExpressionNode);
ValueNode.TOKENS = [TokenType.String, TokenType.Number, TokenType.DynamicIdentifier, TokenType.Date];
let AttributeNode = /*#__PURE__*/function (_ExpressionNode2) {
  _inherits(AttributeNode, _ExpressionNode2);

  var _super2 = /*#__PURE__*/_createSuper(AttributeNode);

  function AttributeNode() {
    _classCallCheck(this, AttributeNode);

    return _super2.apply(this, arguments);
  }

  _createClass(AttributeNode, null, [{
    key: "is",
    value: function is(token) {
      return AttributeNode.TOKENS.includes(token.type);
    }
  }]);

  return AttributeNode;
}(ExpressionNode);
AttributeNode.TOKENS = [TokenType.Identifier];
let OperationNode = /*#__PURE__*/function (_ExpressionNode3) {
  _inherits(OperationNode, _ExpressionNode3);

  var _super3 = /*#__PURE__*/_createSuper(OperationNode);

  function OperationNode() {
    _classCallCheck(this, OperationNode);

    return _super3.apply(this, arguments);
  }

  _createClass(OperationNode, null, [{
    key: "is",
    value: function is(token) {
      return OperationNode.TOKENS.includes(token.type);
    }
  }]);

  return OperationNode;
}(ExpressionNode);
OperationNode.TOKENS = [TokenType.ArEq, TokenType.ArNotEq, TokenType.ArGr, TokenType.ArGre, TokenType.ArLs, TokenType.ArLse, TokenType.ArPlus, TokenType.ArMinus, TokenType.ArDiv, TokenType.ArMul, TokenType.Between, TokenType.Outside];
let BoolOperationNode = /*#__PURE__*/function (_ExpressionNode4) {
  _inherits(BoolOperationNode, _ExpressionNode4);

  var _super4 = /*#__PURE__*/_createSuper(BoolOperationNode);

  function BoolOperationNode() {
    _classCallCheck(this, BoolOperationNode);

    return _super4.apply(this, arguments);
  }

  _createClass(BoolOperationNode, null, [{
    key: "is",
    value: function is(token) {
      return BoolOperationNode.TOKENS.includes(token.type);
    }
  }]);

  return BoolOperationNode;
}(ExpressionNode);
BoolOperationNode.TOKENS = [TokenType.BoolAnd, TokenType.BoolOr];
let FunctionNode = /*#__PURE__*/function (_ExpressionNode5) {
  _inherits(FunctionNode, _ExpressionNode5);

  var _super5 = /*#__PURE__*/_createSuper(FunctionNode);

  function FunctionNode(token, func, left, right) {
    var _this;

    if (left === void 0) {
      left = null;
    }

    if (right === void 0) {
      right = null;
    }

    _classCallCheck(this, FunctionNode);

    _this = _super5.call(this, token, left, right);
    _this.func = func;
    return _this;
  }

  _createClass(FunctionNode, null, [{
    key: "is",
    value: function is(token) {
      return FunctionNode.TOKENS.includes(token.type);
    }
  }]);

  return FunctionNode;
}(ExpressionNode);
FunctionNode.TOKENS = [TokenType.Function];

const OperationPrecedence = /*#__PURE__*/new Map();
OperationPrecedence.set(TokenType.ExprOpen, 0);
OperationPrecedence.set(TokenType.ExprClose, 0);
OperationPrecedence.set(TokenType.BoolAnd, 1);
OperationPrecedence.set(TokenType.BoolOr, 1);
OperationPrecedence.set(TokenType.ArEq, 2);
OperationPrecedence.set(TokenType.ArNotEq, 2);
OperationPrecedence.set(TokenType.ArGr, 2);
OperationPrecedence.set(TokenType.ArGre, 2);
OperationPrecedence.set(TokenType.ArLs, 2);
OperationPrecedence.set(TokenType.ArLse, 2);
OperationPrecedence.set(TokenType.ArPlus, 3);
OperationPrecedence.set(TokenType.ArMinus, 3);
OperationPrecedence.set(TokenType.ArMul, 4);
OperationPrecedence.set(TokenType.ArDiv, 4);
OperationPrecedence.set(TokenType.Function, 5);
OperationPrecedence.set(TokenType.Between, 5);
OperationPrecedence.set(TokenType.Outside, 5);

let TokenError = /*#__PURE__*/function (_Error) {
  _inherits(TokenError, _Error);

  var _super = /*#__PURE__*/_createSuper(TokenError);

  function TokenError(message, position) {
    var _this;

    if (position === void 0) {
      position = DEFAULT_TOKEN_POSITION;
    }

    _classCallCheck(this, TokenError);

    _this = _super.call(this);
    _this.position = position;
    const {
      start,
      end
    } = position;
    _this.message = _this.name + "(c\u0438\u043C\u0432\u043E\u043B: " + (start + 1) + ", " + (end + 1) + "):" + message + ".";
    return _this;
  }

  return _createClass(TokenError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

let LintError = /*#__PURE__*/function (_TokenError) {
  _inherits(LintError, _TokenError);

  var _super = /*#__PURE__*/_createSuper(LintError);

  function LintError(message, position) {
    var _this;

    if (position === void 0) {
      position = DEFAULT_TOKEN_POSITION;
    }

    _classCallCheck(this, LintError);

    _this = _super.call(this, message, position);
    _this.position = position;
    _this.name = 'LintError';
    return _this;
  }

  return _createClass(LintError);
}(TokenError);

const last = el => el[el.length - 1];

const isOperand = token => ValueNode.is(token) || AttributeNode.is(token);

const isOperation = token => OperationNode.is(token) || BoolOperationNode.is(token) || FunctionNode.is(token);

const isHigherPrecedence = (tokenOne, tokenTwo) => OperationPrecedence.get(tokenOne.type) > OperationPrecedence.get(tokenTwo.type); // TODO parentheses

/*
  https://en.wikipedia.org/wiki/Shunting-yard_algorithm
*/


function shuntingYard(tokens) {
  let output = [];
  const operators = [];

  for (const token of tokens) {
    if (isOperand(token)) {
      output.push(token);
    }

    if (isOperation(token)) {
      if (![TokenType.Between, TokenType.Outside].includes(token.type)) {
        while (last(operators) && isHigherPrecedence(last(operators), token) && last(operators).type !== TokenType.ExprOpen) {
          output.push(operators.pop());
        }
      }

      operators.push(token);
    }

    if (token.type === TokenType.ExprOpen) {
      operators.push(token);
    }

    if (token.type === TokenType.ExprClose) {
      const closeParen = token;

      while (last(operators) && last(operators).type !== TokenType.ExprOpen) {
        output.push(operators.pop());
      }

      if (operators.length === 0) {
        throw new LintError("\u041F\u0440\u043E\u043F\u0443\u0449\u0435\u043D\u0430 \u043E\u0442\u043A\u0440\u044B\u0432\u0430\u044E\u0449\u0430\u044F \u0441\u043A\u043E\u0431\u043A\u0430", closeParen.position);
      }

      if (last(operators).type === TokenType.ExprOpen) {
        operators.pop();
      }
    }
  }

  if (operators.length) {
    const lastToken = last(operators);

    if (lastToken.type === TokenType.ExprOpen) {
      throw new LintError("\u041F\u0440\u043E\u043F\u0443\u0449\u0435\u043D\u0430 \u0437\u0430\u043A\u0440\u044B\u0432\u0430\u044E\u0449\u0430\u044F \u0441\u043A\u043E\u0431\u043A\u0430", lastToken.position);
    }

    output = [...output, ...operators.reverse()];
  }

  return output;
}

let ExpressionAstError = /*#__PURE__*/function (_TokenError) {
  _inherits(ExpressionAstError, _TokenError);

  var _super = /*#__PURE__*/_createSuper(ExpressionAstError);

  function ExpressionAstError(message, position) {
    var _this;

    if (position === void 0) {
      position = DEFAULT_TOKEN_POSITION;
    }

    _classCallCheck(this, ExpressionAstError);

    _this = _super.call(this, message, position);
    _this.position = position;
    _this.name = 'ExpressionAst';
    return _this;
  }

  return _createClass(ExpressionAstError);
}(TokenError);

let ExpressionVisitor = /*#__PURE__*/function () {
  function ExpressionVisitor() {
    _classCallCheck(this, ExpressionVisitor);
  }

  _createClass(ExpressionVisitor, [{
    key: "visit",
    value: function visit(node) {
      if (node instanceof BoolOperationNode) {
        return this.visitBoolOpNode(node);
      }

      if (node instanceof OperationNode) {
        return this.visitOpNode(node);
      }

      if (node instanceof ValueNode) {
        return this.visitValueNode(node);
      }

      if (node instanceof AttributeNode) {
        return this.visitAttributeNode(node);
      }

      if (node instanceof FunctionNode) {
        return this.visitFunctionNode(node);
      }
    }
  }, {
    key: "visitBoolOpNode",
    value: function visitBoolOpNode(_node) {}
  }, {
    key: "visitOpNode",
    value: function visitOpNode(_node) {}
  }, {
    key: "visitValueNode",
    value: function visitValueNode(_node) {}
  }, {
    key: "visitAttributeNode",
    value: function visitAttributeNode(_node) {}
  }, {
    key: "visitFunctionNode",
    value: function visitFunctionNode(_node) {}
  }]);

  return ExpressionVisitor;
}();

let LintVisitor = /*#__PURE__*/function (_ExpressionVisitor) {
  _inherits(LintVisitor, _ExpressionVisitor);

  var _super = /*#__PURE__*/_createSuper(LintVisitor);

  function LintVisitor(attributes) {
    var _this;

    _classCallCheck(this, LintVisitor);

    _this = _super.call(this);
    _this.attributes = attributes;
    return _this;
  }

  _createClass(LintVisitor, [{
    key: "visitBoolOpNode",
    value: function visitBoolOpNode(node) {
      _get(_getPrototypeOf(LintVisitor.prototype), "visitBoolOpNode", this).call(this, node);

      this.checkBoolOpNode(node);
      this.acceptLeafs(node);
    }
  }, {
    key: "visitOpNode",
    value: function visitOpNode(node) {
      _get(_getPrototypeOf(LintVisitor.prototype), "visitOpNode", this).call(this, node);

      this.checkOpNode(node);
      this.acceptLeafs(node);
    } // TODO check attributes types and value

  }, {
    key: "visitValueNode",
    value: function visitValueNode(node) {
      _get(_getPrototypeOf(LintVisitor.prototype), "visitValueNode", this).call(this, node);

      this.checkLeafNode(node);
    }
  }, {
    key: "visitAttributeNode",
    value: function visitAttributeNode(node) {
      _get(_getPrototypeOf(LintVisitor.prototype), "visitAttributeNode", this).call(this, node);

      this.checkLeafNode(node);
      this.checkAttributeNode(node);
    }
  }, {
    key: "visitFunctionNode",
    value: function visitFunctionNode(node) {
      _get(_getPrototypeOf(LintVisitor.prototype), "visitFunctionNode", this).call(this, node);

      this.checkLeafNode(node);
      this.checkFunctionNode(node);
    }
  }, {
    key: "checkBoolOpNode",
    value: function checkBoolOpNode(node) {
      const message = "\u041E\u0436\u0438\u0434\u0430\u0435\u0442\u0441\u044F \u0432\u044B\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0432\u0438\u0434\u0430 'a == 2 " + node.token.value + " b == 3'";

      if (!this.isOperationNode(node.left)) {
        this.Error(message, node.token);
      }

      if (!this.isOperationNode(node.right)) {
        this.Error(message, node.token);
      }
    }
  }, {
    key: "checkOpNode",
    value: function checkOpNode(node) {
      if (!node.left || !node.right) {
        this.Error("'" + node.token.value + "' \u043E\u0436\u0438\u0434\u0430\u0435\u0442 \u0432\u044B\u0440\u0430\u0436\u0435\u043D\u0438\u0435", node.token);
      }
    }
  }, {
    key: "checkLeafNode",
    value: function checkLeafNode(node) {
      if (node.left) {
        const {
          token
        } = node.left;
        this.Error("'" + token.value + "' \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0432\u043D\u0435 \u0432\u044B\u0440\u0430\u0436\u0435\u043D\u0438\u044F", token);
      }

      if (node.right) {
        const {
          token
        } = node.right;
        this.Error("'" + token.value + "' \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0432\u043D\u0435 \u0432\u044B\u0440\u0430\u0436\u0435\u043D\u0438\u044F", token);
      }
    }
  }, {
    key: "checkAttributeNode",
    value: function checkAttributeNode(node) {
      if (!node.token.value || this.attributes[node.token.value] === undefined) {
        this.Error("\u0410\u0442\u0440\u0438\u0431\u0443\u0442 '" + node.token.value + "' \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D \u0432 \u0430\u0442\u0440\u0438\u0431\u0443\u0442\u0430\u0445 \u0441\u043B\u043E\u044F", node.token);
      }
    }
  }, {
    key: "checkFunctionNode",
    value: function checkFunctionNode(node) {
      const result = node.func.check(this.attributes);

      if (result instanceof Error) {
        this.Error(result.message, node.token);
      }
    }
  }, {
    key: "Error",
    value: function Error(description, token) {
      const {
        position
      } = token;
      throw new LintError(description, position);
    }
  }, {
    key: "acceptLeafs",
    value: function acceptLeafs(node) {
      const x = node.left && node.left.accept(this);
      const y = node.right && node.right.accept(this);
      return {
        x,
        y
      };
    }
  }, {
    key: "isOperationNode",
    value: function isOperationNode(node) {
      return node instanceof BoolOperationNode || node instanceof OperationNode;
    }
  }]);

  return LintVisitor;
}(ExpressionVisitor);

let EvaluateVisitor = /*#__PURE__*/function (_LintVisitor) {
  _inherits(EvaluateVisitor, _LintVisitor);

  var _super = /*#__PURE__*/_createSuper(EvaluateVisitor);

  function EvaluateVisitor(attributes, options) {
    var _this;

    _classCallCheck(this, EvaluateVisitor);

    _this = _super.call(this, attributes);
    _this.attributes = attributes;
    _this.silent = !!(options && options.silent);
    return _this;
  }

  _createClass(EvaluateVisitor, [{
    key: "visitBoolOpNode",
    value: function visitBoolOpNode(node) {
      if (!this.silent) {
        _get(_getPrototypeOf(EvaluateVisitor.prototype), "visitBoolOpNode", this).call(this, node);
      }

      const {
        x,
        y
      } = this.acceptLeafs(node);
      return node.token.type === TokenType.BoolAnd ? x && y : x || y;
    }
  }, {
    key: "visitOpNode",
    value: function visitOpNode(node) {
      if (!this.silent) {
        _get(_getPrototypeOf(EvaluateVisitor.prototype), "visitOpNode", this).call(this, node);
      }

      const {
        x,
        y
      } = this.acceptLeafs(node);

      switch (node.token.type) {
        case TokenType.ArEq:
          return x === y;

        case TokenType.ArNotEq:
          return x !== y;

        case TokenType.ArGre:
          return x >= y;

        case TokenType.ArLse:
          return x <= y;

        case TokenType.ArGr:
          return x > y;

        case TokenType.ArLs:
          return x < y;

        case TokenType.ArPlus:
          return x + y;

        case TokenType.ArMinus:
          return x - y;

        case TokenType.ArMul:
          return x * y;

        case TokenType.ArDiv:
          return x / y;

        default:
          return false;
      }
    }
  }, {
    key: "visitValueNode",
    value: function visitValueNode(node) {
      if (!this.silent) {
        _get(_getPrototypeOf(EvaluateVisitor.prototype), "visitValueNode", this).call(this, node);
      }

      return node.token.value;
    }
  }, {
    key: "visitAttributeNode",
    value: function visitAttributeNode(node) {
      if (!this.silent) {
        _get(_getPrototypeOf(EvaluateVisitor.prototype), "visitAttributeNode", this).call(this, node);
      }

      return this.attributes[node.token.value];
    }
  }, {
    key: "visitFunctionNode",
    value: function visitFunctionNode(node) {
      if (!this.silent) {
        _get(_getPrototypeOf(EvaluateVisitor.prototype), "visitFunctionNode", this).call(this, node);
      }

      return node.func.calc(this.attributes);
    }
  }]);

  return EvaluateVisitor;
}(LintVisitor);

let EqlFunction = /*#__PURE__*/function () {
  function EqlFunction(args) {
    _classCallCheck(this, EqlFunction);

    this.args = args;
  }

  _createClass(EqlFunction, [{
    key: "calc",
    value: function calc(_attributes) {
      // TODO
      return 0;
    }
  }, {
    key: "evaluateArguments",
    value: function evaluateArguments(attributes) {
      return this.args.map(arg => {
        if (arg instanceof OperationNode) {
          return arg.accept(new EvaluateVisitor(attributes));
        }

        if (typeof arg.value === 'string') {
          const value = attributes[arg.value];

          if (typeof value !== 'number') {
            const {
              position
            } = arg;
            throw new LintError('Аргумент функции должен быть числовым типом', position);
          }

          return attributes[arg.value];
        }

        return arg.value;
      });
    }
  }, {
    key: "check",
    value: function check(attributes, argsCount) {
      const args = this.evaluateArguments(attributes);

      if (args.length !== argsCount) {
        return new Error('Передано неверное количество аргументов');
      }

      return null;
    }
  }]);

  return EqlFunction;
}();

let Sin = /*#__PURE__*/function (_EqlFunction) {
  _inherits(Sin, _EqlFunction);

  var _super = /*#__PURE__*/_createSuper(Sin);

  function Sin() {
    _classCallCheck(this, Sin);

    return _super.apply(this, arguments);
  }

  _createClass(Sin, [{
    key: "calc",
    value: function calc(attributes) {
      const [arg] = _get(_getPrototypeOf(Sin.prototype), "evaluateArguments", this).call(this, attributes);

      return +Math.sin(arg).toFixed(3);
    }
  }, {
    key: "check",
    value: function check(attributes) {
      return _get(_getPrototypeOf(Sin.prototype), "check", this).call(this, attributes, Sin.ArgsCount);
    }
  }]);

  return Sin;
}(EqlFunction);
Sin.ArgsCount = 1;
Sin.Name = 'sin';

let ArcSin = /*#__PURE__*/function (_EqlFunction) {
  _inherits(ArcSin, _EqlFunction);

  var _super = /*#__PURE__*/_createSuper(ArcSin);

  function ArcSin() {
    _classCallCheck(this, ArcSin);

    return _super.apply(this, arguments);
  }

  _createClass(ArcSin, [{
    key: "calc",
    value: function calc(attributes) {
      const [arg] = _get(_getPrototypeOf(ArcSin.prototype), "evaluateArguments", this).call(this, attributes);

      return +Math.asin(arg).toFixed(3);
    }
  }, {
    key: "check",
    value: function check(attributes) {
      return _get(_getPrototypeOf(ArcSin.prototype), "check", this).call(this, attributes, ArcSin.ArgsCount);
    }
  }]);

  return ArcSin;
}(EqlFunction);
ArcSin.ArgsCount = 1;
ArcSin.Name = 'arcsin';

let Cos = /*#__PURE__*/function (_EqlFunction) {
  _inherits(Cos, _EqlFunction);

  var _super = /*#__PURE__*/_createSuper(Cos);

  function Cos() {
    _classCallCheck(this, Cos);

    return _super.apply(this, arguments);
  }

  _createClass(Cos, [{
    key: "calc",
    value: function calc(attributes) {
      const [arg] = _get(_getPrototypeOf(Cos.prototype), "evaluateArguments", this).call(this, attributes);

      return +Math.cos(arg).toFixed(3);
    }
  }, {
    key: "check",
    value: function check(attributes) {
      return _get(_getPrototypeOf(Cos.prototype), "check", this).call(this, attributes, Cos.ArgsCount);
    }
  }]);

  return Cos;
}(EqlFunction);
Cos.ArgsCount = 1;
Cos.Name = 'cos';

let ArcCos = /*#__PURE__*/function (_EqlFunction) {
  _inherits(ArcCos, _EqlFunction);

  var _super = /*#__PURE__*/_createSuper(ArcCos);

  function ArcCos() {
    _classCallCheck(this, ArcCos);

    return _super.apply(this, arguments);
  }

  _createClass(ArcCos, [{
    key: "calc",
    value: function calc(attributes) {
      const [arg] = _get(_getPrototypeOf(ArcCos.prototype), "evaluateArguments", this).call(this, attributes);

      return +Math.acos(arg).toFixed(3);
    }
  }, {
    key: "check",
    value: function check(attributes) {
      return _get(_getPrototypeOf(ArcCos.prototype), "check", this).call(this, attributes, ArcCos.ArgsCount);
    }
  }]);

  return ArcCos;
}(EqlFunction);
ArcCos.ArgsCount = 1;
ArcCos.Name = 'arccos';

let ArcTan2 = /*#__PURE__*/function (_EqlFunction) {
  _inherits(ArcTan2, _EqlFunction);

  var _super = /*#__PURE__*/_createSuper(ArcTan2);

  function ArcTan2() {
    _classCallCheck(this, ArcTan2);

    return _super.apply(this, arguments);
  }

  _createClass(ArcTan2, [{
    key: "calc",
    value: function calc(attributes) {
      const [arg1, arg2] = _get(_getPrototypeOf(ArcTan2.prototype), "evaluateArguments", this).call(this, attributes);

      return +Math.atan2(arg1, arg2).toFixed(3);
    }
  }, {
    key: "check",
    value: function check(attributes) {
      return _get(_getPrototypeOf(ArcTan2.prototype), "check", this).call(this, attributes, ArcTan2.ArgsCount);
    }
  }]);

  return ArcTan2;
}(EqlFunction);
ArcTan2.ArgsCount = 2;
ArcTan2.Name = 'arctan2';

let Tan = /*#__PURE__*/function (_EqlFunction) {
  _inherits(Tan, _EqlFunction);

  var _super = /*#__PURE__*/_createSuper(Tan);

  function Tan() {
    _classCallCheck(this, Tan);

    return _super.apply(this, arguments);
  }

  _createClass(Tan, [{
    key: "calc",
    value: function calc(attributes) {
      const [arg] = _get(_getPrototypeOf(Tan.prototype), "evaluateArguments", this).call(this, attributes);

      return +Math.tan(arg).toFixed(3);
    }
  }, {
    key: "check",
    value: function check(attributes) {
      return _get(_getPrototypeOf(Tan.prototype), "check", this).call(this, attributes, Tan.ArgsCount);
    }
  }]);

  return Tan;
}(EqlFunction);
Tan.ArgsCount = 1;
Tan.Name = 'tan';

let ArcTan = /*#__PURE__*/function (_EqlFunction) {
  _inherits(ArcTan, _EqlFunction);

  var _super = /*#__PURE__*/_createSuper(ArcTan);

  function ArcTan() {
    _classCallCheck(this, ArcTan);

    return _super.apply(this, arguments);
  }

  _createClass(ArcTan, [{
    key: "calc",
    value: function calc(attributes) {
      const [arg] = _get(_getPrototypeOf(ArcTan.prototype), "evaluateArguments", this).call(this, attributes);

      return +Math.atan(arg).toFixed(3);
    }
  }, {
    key: "check",
    value: function check(attributes) {
      return _get(_getPrototypeOf(ArcTan.prototype), "check", this).call(this, attributes, ArcTan.ArgsCount);
    }
  }]);

  return ArcTan;
}(EqlFunction);
ArcTan.ArgsCount = 1;
ArcTan.Name = 'arctan';

let Sqrt = /*#__PURE__*/function (_EqlFunction) {
  _inherits(Sqrt, _EqlFunction);

  var _super = /*#__PURE__*/_createSuper(Sqrt);

  function Sqrt() {
    _classCallCheck(this, Sqrt);

    return _super.apply(this, arguments);
  }

  _createClass(Sqrt, [{
    key: "calc",
    value: function calc(attributes) {
      const [arg] = _get(_getPrototypeOf(Sqrt.prototype), "evaluateArguments", this).call(this, attributes);

      return +Math.sqrt(arg).toFixed(3);
    }
  }, {
    key: "check",
    value: function check(attributes) {
      return _get(_getPrototypeOf(Sqrt.prototype), "check", this).call(this, attributes, Sqrt.ArgsCount);
    }
  }]);

  return Sqrt;
}(EqlFunction);
Sqrt.ArgsCount = 1;
Sqrt.Name = 'sqrt';

const EqlFunctions = {
  [Sin.Name]: Sin,
  [ArcSin.Name]: ArcSin,
  [Cos.Name]: Cos,
  [ArcCos.Name]: ArcCos,
  [Tan.Name]: Tan,
  [ArcTan.Name]: ArcTan,
  [ArcTan2.Name]: ArcTan2,
  [Sqrt.Name]: Sqrt
};

const formatValue = value => !isValid(value) ? "#'" + value + "'" : value;

let ExpressionAst = /*#__PURE__*/function () {
  function ExpressionAst(tokens) {
    _classCallCheck(this, ExpressionAst);

    this.tokens = tokens;
    this.tree = null;
    this.currentPosition = 0;
  } // TODO refactoring needed
  // @ts-ignore


  _createClass(ExpressionAst, [{
    key: "value",
    get: function get() {
      if (this.tree) {
        return this.tree;
      }

      this.tokens = shuntingYard(this.tokens);
      const stack = [];

      for (; this.currentPosition < this.tokens.length; this.nextToken()) {
        if (ValueNode.is(this.currentToken)) {
          stack.push(new ValueNode(this.currentToken));
        }

        if (AttributeNode.is(this.currentToken)) {
          stack.push(new AttributeNode(this.currentToken));
        }

        if (FunctionNode.is(this.currentToken)) {
          const FnConstructor = EqlFunctions[this.currentToken.value];

          if (!FnConstructor) {
            this.Error("\u0424\u0443\u043D\u043A\u0446\u0438\u044F '" + this.currentToken.value + "' \u043D\u0435 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0430", this.currentToken);
          }

          const args = [];

          for (let i = 0; i < FnConstructor.ArgsCount; i++) {
            const node = stack.pop() || null;

            if (node instanceof OperationNode) {
              args.push(node);
            } else if (node && node.token) {
              // @ts-ignore
              args.push(node.token);
            }
          }

          const fn = new FnConstructor(args);
          stack.push(new FunctionNode(this.currentToken, fn));
        }

        if (OperationNode.is(this.currentToken)) {
          const node = new OperationNode(this.currentToken);

          if ([TokenType.Between, TokenType.Outside].includes(this.currentToken.type)) {
            var _value1$token$positio, _value2$token$positio;

            const value2 = stack.pop() || null;
            const value1 = stack.pop() || null;
            node.left = stack.pop() || null;
            node.right = new ValueNode(_extends({}, this.currentToken, {
              value: formatValue(value1 == null ? void 0 : value1.token.value) + " - " + formatValue(value2 == null ? void 0 : value2.token.value),
              position: {
                start: (value1 == null ? void 0 : (_value1$token$positio = value1.token.position) == null ? void 0 : _value1$token$positio.start) || 0,
                end: (value2 == null ? void 0 : (_value2$token$positio = value2.token.position) == null ? void 0 : _value2$token$positio.end) || 0
              }
            }));
          } else {
            if (stack.length > 1) {
              node.right = stack.pop() || null;
            }

            node.left = stack.pop() || null;
          }

          stack.push(node);
        }

        if (BoolOperationNode.is(this.currentToken)) {
          const node = new BoolOperationNode(this.currentToken);

          if (stack.length > 1) {
            node.right = stack.pop() || null;
          }

          node.left = stack.pop() || null;
          stack.push(node);
        }
      }

      this.tree = stack.pop() || null;
      this.flashStack(stack);
      this.checkRoot();
      return this.tree;
    }
  }, {
    key: "nextToken",
    value: function nextToken() {
      this.currentPosition += 1;
    } // @ts-ignore

  }, {
    key: "currentToken",
    get: function get() {
      return this.tokens[this.currentPosition];
    }
  }, {
    key: "checkRoot",
    value: function checkRoot() {
      if (!this.tree) {
        return;
      }
    }
  }, {
    key: "flashStack",
    value: function flashStack(stack) {
      if (!this.tree || !stack.length) {
        return;
      }

      while (stack.length) {
        const node = stack.pop();

        if (node) {
          this.insert(this.tree, node);
        }
      }
    }
  }, {
    key: "insert",
    value: function insert(tree, node) {
      if (tree.right === null) {
        tree.right = node;
        return;
      } else {
        this.insert(tree.right, node);
      }
    }
  }, {
    key: "Error",
    value: function Error(description, token) {
      const {
        position
      } = token;
      const {
        start,
        end
      } = position;
      throw new ExpressionAstError(description, {
        start,
        end
      });
    }
  }]);

  return ExpressionAst;
}();

let ExpressionTokenizerError = /*#__PURE__*/function (_TokenError) {
  _inherits(ExpressionTokenizerError, _TokenError);

  var _super = /*#__PURE__*/_createSuper(ExpressionTokenizerError);

  function ExpressionTokenizerError(message, position) {
    var _this;

    if (position === void 0) {
      position = DEFAULT_TOKEN_POSITION;
    }

    _classCallCheck(this, ExpressionTokenizerError);

    _this = _super.call(this, message, position);
    _this.position = position;
    _this.name = 'ExpressionTokenizer';
    return _this;
  }

  return _createClass(ExpressionTokenizerError);
}(TokenError);

let OperationAccept = /*#__PURE__*/function () {
  function OperationAccept(value, type, operations) {
    if (operations === void 0) {
      operations = [];
    }

    _classCallCheck(this, OperationAccept);

    this.acceptMap = new Map();
    this.value = value;
    this.tokenType = type;
    operations.map(opAccept => this.acceptMap.set(opAccept.value, opAccept));
  }

  _createClass(OperationAccept, [{
    key: "accept",
    value: function accept(char) {
      return this.acceptMap.get(char) || null;
    }
  }]);

  return OperationAccept;
}();

let Char = /*#__PURE__*/function () {
  function Char() {
    _classCallCheck(this, Char);
  }

  _createClass(Char, null, [{
    key: "isChar",
    value: function isChar(char) {
      return typeof char === 'string' && char.length === 1;
    }
  }, {
    key: "isDigit",
    value: function isDigit(char) {
      return this.isChar(char) && /\d/.test(char);
    }
  }, {
    key: "isLetter",
    value: function isLetter(char) {
      return this.isChar(char) && /\w/.test(char);
    }
  }, {
    key: "isWhiteSpace",
    value: function isWhiteSpace(char) {
      return this.isChar(char) && char === Char.WHITE_SPACE;
    }
  }, {
    key: "isLetterOrDigit",
    value: function isLetterOrDigit(char) {
      return Char.isLetter(char) || Char.isDigit(char);
    }
  }, {
    key: "isUnderscore",
    value: function isUnderscore(char) {
      return Char.isChar(char) && char === Char.UNDERSCORE;
    }
  }, {
    key: "isFloating",
    value: function isFloating(char) {
      return Char.isChar(char) && (char === 'f' || char === 'F');
    }
  }, {
    key: "escapeSpecChars",
    value: function escapeSpecChars(str) {
      return str.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/"/g, '\\"').replace(/\t/g, '\\\\t').replace(/\v/g, '\\\\v').replace(/\0/g, '\\\\0').replace(/\f/g, '\\\\f').replace(/\n/g, '\\\\n').replace(/\r/g, '\\\\r');
    }
  }, {
    key: "unEscapeSpecChars",
    value: function unEscapeSpecChars(str) {
      return str.replace(/\\'/g, "'").replace(/\\"/g, '"').replace(/\\\\/g, '\\').replace(/\\\\t/g, '\t').replace(/\\\\v/g, '\v').replace(/\\\\0/g, '\0').replace(/\\\\f/g, '\f').replace(/\\\\n/g, '\n').replace(/\\\\r/g, '\r');
    }
  }]);

  return Char;
}();
Char.LEFT_BRACKET = '{';
Char.OPEN_BRACKET = '(';
Char.BETWEEN = 'between';
Char.OUTSIDE = '!between';
Char.SINGLE_QUOTE = "'";
Char.DOUBLE_QUOTE = '"';
Char.HASH_SYMBOL = '#';
Char.RIGHT_BRACKET = '}';
Char.CLOSE_BRACKET = ')';
Char.BACK_SLASH = '\\';
Char.WHITE_SPACE = ' ';
Char.UNDERSCORE = '_';
Char.PERCENTAGE = '%';
Char.POINT = '.';

function isObject(value) {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

let Time = /*#__PURE__*/_createClass(function Time() {
  _classCallCheck(this, Time);
});

Time.sToMs = seconds => seconds * 1000;

Time.mToMs = minutes => Time.sToMs(minutes) * 60;

Time.hToMs = hours => Time.mToMs(hours) * 60;

Time.dToMs = days => Time.hToMs(days) * 24;

Time.mthToMs = months => Time.dToMs(months) * 30;

Time.yToMs = years => Time.mthToMs(years) * 365;

const AcceptTree = /*#__PURE__*/new OperationAccept('', TokenType.Null, [/*#__PURE__*/new OperationAccept(Char.BETWEEN, TokenType.Between), /*#__PURE__*/new OperationAccept(Char.OUTSIDE, TokenType.Outside), /*#__PURE__*/new OperationAccept('>', TokenType.ArGr, [/*#__PURE__*/new OperationAccept('=', TokenType.ArGre)]), /*#__PURE__*/new OperationAccept('<', TokenType.ArLs, [/*#__PURE__*/new OperationAccept('=', TokenType.ArLse)]), /*#__PURE__*/new OperationAccept('!', TokenType.BoolNot, [/*#__PURE__*/new OperationAccept('=', TokenType.ArNotEq)]), /*#__PURE__*/new OperationAccept('&', TokenType.Null, [/*#__PURE__*/new OperationAccept('&', TokenType.BoolAnd)]), /*#__PURE__*/new OperationAccept('=', TokenType.ArEq, [/*#__PURE__*/new OperationAccept('=', TokenType.ArEq)]), /*#__PURE__*/new OperationAccept('|', TokenType.Null, [/*#__PURE__*/new OperationAccept('|', TokenType.BoolOr)]), /*#__PURE__*/new OperationAccept('+', TokenType.ArPlus), /*#__PURE__*/new OperationAccept('-', TokenType.ArMinus), /*#__PURE__*/new OperationAccept('*', TokenType.ArMul), /*#__PURE__*/new OperationAccept('/', TokenType.ArDiv), /*#__PURE__*/new OperationAccept('(', TokenType.ExprOpen), /*#__PURE__*/new OperationAccept(')', TokenType.ExprClose), /*#__PURE__*/new OperationAccept('[', TokenType.ArrayOpen), /*#__PURE__*/new OperationAccept(']', TokenType.ArrayClose), /*#__PURE__*/new OperationAccept(',', TokenType.Separator)]);

const TOKENIZER_MAX_SIZE = 1000;
let ExpressionTokenizer = /*#__PURE__*/function () {
  function ExpressionTokenizer(input, tokenizerMaxSize) {
    _classCallCheck(this, ExpressionTokenizer);

    this.start = 0;
    this.currentPosition = 0;
    this.tokens = [];
    this.tokenizerMaxSize = TOKENIZER_MAX_SIZE;
    this.input = input || '';
    this.tokenizerMaxSize = tokenizerMaxSize || TOKENIZER_MAX_SIZE;
  }

  _createClass(ExpressionTokenizer, [{
    key: "tokenize",
    value: function tokenize() {
      if (this.isEndOfString()) {
        return this.tokens;
      }

      while (true) {
        const token = this.nextToken();

        if (!token) {
          break;
        }

        this.tokens.push(token);

        if (this.tokens.length > this.tokenizerMaxSize) {
          this.Error("\u041F\u0440\u0435\u0432\u044B\u0448\u0435\u043D \u043B\u0438\u043C\u0438\u0442 \u0437\u0430\u043F\u0440\u043E\u0441\u0430: " + this.tokenizerMaxSize);
        }

        if (token.type === TokenType.EndOfString) {
          break;
        }
      }

      return this.tokens;
    }
  }, {
    key: "nextToken",
    value: function nextToken() {
      for (; this.currentPosition < this.input.length; this.nextSymbol()) {
        if (Char.isWhiteSpace(this.current)) {
          continue;
        }

        this.resetStart();

        if (this.input.slice(this.currentPosition).startsWith(Char.OUTSIDE)) {
          this.currentPosition += Char.OUTSIDE.length;
          return this.createToken(TokenType.Outside, Char.OUTSIDE);
        }

        if (this.input.slice(this.currentPosition).startsWith(Char.BETWEEN)) {
          this.currentPosition += Char.BETWEEN.length;
          return this.createToken(TokenType.Between, Char.BETWEEN);
        }

        const acceptOp = AcceptTree.accept(this.current);

        if (acceptOp !== null) {
          return this.captureSpecial(acceptOp);
        }

        if (Char.isDigit(this.current) || this.current === Char.POINT) {
          return this.captureNumber();
        }

        if (Char.isLetter(this.current) || Char.isUnderscore(this.current)) {
          return this.captureIdentifier();
        }

        if (this.current === Char.LEFT_BRACKET) {
          return this.captureDynamicIdentifier();
        }

        if (this.current === Char.DOUBLE_QUOTE || this.current === Char.SINGLE_QUOTE) {
          return this.captureString();
        }

        if (this.current === Char.HASH_SYMBOL) {
          return this.captureDate();
        }
      } // TODO


      this.resetStart();
      return this.createToken(TokenType.EndOfString);
    }
  }, {
    key: "resetStart",
    value: function resetStart() {
      this.start = this.currentPosition;
    }
  }, {
    key: "createToken",
    value: function createToken(tokenType, // @ts-ignore
    value) {
      if (value === void 0) {
        value = null;
      }

      // TODO
      const end = this.currentPosition - (tokenType === TokenType.EndOfString ? 0 : 1);
      return new Token(tokenType, value, {
        start: this.start,
        end
      });
    }
  }, {
    key: "nextSymbol",
    value: function nextSymbol() {
      this.currentPosition += 1;
    }
  }, {
    key: "current",
    get: function get() {
      return this.input[this.currentPosition];
    }
  }, {
    key: "captureSpecial",
    value: function captureSpecial(op) {
      let value = this.current;
      this.nextSymbol();

      for (; this.currentPosition < this.input.length; this.nextSymbol()) {
        const next = op.accept(this.current);

        if (next === null || next.tokenType === TokenType.Null) {
          break;
        }

        value += this.current;
        op = next;
      }

      const isUnaryOp = this.current && Char.isDigit(this.current) && op.tokenType === TokenType.ArMinus; // TODO change if unary operations will needed... why is that here?

      if (isUnaryOp) {
        return this.createToken(TokenType.Number, -(this.captureNumber().value || 0));
      }

      if (op.tokenType === TokenType.Null) {
        this.Error("\u041D\u0435\u0438\u0437\u0432\u0435c\u0442\u043D\u0430\u044F \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u044F '" + op.value + "'");
      }

      return this.createToken(op.tokenType, value);
    }
  }, {
    key: "captureNumber",
    value: function captureNumber() {
      let result = '';
      let firstPoint = false;

      for (; this.currentPosition < this.input.length; this.nextSymbol()) {
        const skip = Char.isWhiteSpace(this.current) || !Char.isDigit(this.current) && !Char.isFloating(this.current) && this.current !== Char.POINT;

        if (skip) {
          break;
        }

        if (this.current === Char.POINT) {
          firstPoint = true;
        }

        result += this.current;
      }

      if (firstPoint && Char.isFloating(result[result.length - 1])) {
        result = result.slice(0, -1);
      }

      const numValue = parseFloat(result);

      if (Number.isNaN(numValue)) {
        this.Error("\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0447\u0438\u0441\u043B\u043E\u0432\u043E\u0439 \u0444\u043E\u0440\u043C\u0430\u0442: " + result);
      }

      return this.createToken(TokenType.Number, numValue);
    }
  }, {
    key: "captureIdentifier",
    value: function captureIdentifier() {
      let result = '';

      for (; this.currentPosition < this.input.length; this.nextSymbol()) {
        const skip = !(Char.isLetterOrDigit(this.current) || Char.isUnderscore(this.current));

        if (skip) {
          break;
        }

        result += this.current;
      }

      if (this.current === Char.OPEN_BRACKET) {
        const isBetween = this.tokens.some(token => token.type === TokenType.Between);
        const isOutside = this.tokens.some(token => token.type === TokenType.Outside);
        return this.createToken(isOutside ? TokenType.Outside : isBetween ? TokenType.Between : TokenType.Function, result);
      }

      if (result === 'true' || result === 'True' || result === 'TRUE') {
        return this.createToken(TokenType.Terminal, true);
      }

      if (result === 'false' || result === 'False' || result === 'FALSE') {
        return this.createToken(TokenType.Terminal, false);
      }

      if (result === 'in' || result === 'IN') {
        return this.createToken(TokenType.ArIn);
      }

      return this.createToken(TokenType.Identifier, result);
    }
  }, {
    key: "captureDynamicIdentifier",
    value: function captureDynamicIdentifier() {
      this.nextSymbol();
      let result = '';

      for (; this.currentPosition < this.input.length; this.nextSymbol()) {
        if (this.current === Char.RIGHT_BRACKET) {
          this.nextSymbol();
          break;
        }

        result += this.current;
      }

      if (result === 'null' || result === 'Null' || result === 'NULL') {
        return this.createToken(TokenType.DynamicIdentifier, null);
      }

      return this.createToken(TokenType.DynamicIdentifier, result);
    } // @ts-ignore

  }, {
    key: "captureString",
    value: function captureString() {
      let result = '';
      let escaping = false;
      const start = this.current;
      this.nextSymbol();

      for (; this.currentPosition < this.input.length; this.nextSymbol()) {
        if (!escaping && this.current === Char.BACK_SLASH) {
          escaping = true;
          continue;
        }

        if (!escaping && this.current === start) {
          this.nextSymbol();
          return this.createToken(TokenType.String, result);
        }

        result += this.current;
        escaping = false;
      }

      this.Error('Открытая строка');
    }
  }, {
    key: "captureDate",
    value: function captureDate() {
      this.nextSymbol();

      if (![Char.SINGLE_QUOTE, Char.DOUBLE_QUOTE, Char.BACK_SLASH].includes(this.current)) {
        return this.captureTimeSpan();
      }

      const stringToken = this.captureString();
      return this.createToken(TokenType.Date, stringToken.value);
    }
  }, {
    key: "captureTimeSpan",
    value: function captureTimeSpan() {
      let result = '';

      for (; this.currentPosition < this.input.length; this.nextSymbol()) {
        if (!Char.isDigit(this.current)) {
          break;
        }

        result += this.current;
      }

      const number = parseFloat(result);

      if (Number.isNaN(number)) {
        this.Error("\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u0447\u0438\u0441\u043B\u0430 \u0434\u043B\u044F \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F timespan: " + result + ". \u0414\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u043F\u043E\u043B\u043E\u0436\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u043C \u0446\u0435\u043B\u043E\u0447\u0438\u0441\u043B\u0435\u043D\u043D\u044B\u043C \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u043C.");
      }

      if (!Char.isLetter(this.current)) {
        this.Error("\u0414\u043B\u044F \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u0437\u0430\u0434\u0430\u043D\u0430 \u043D\u0435\u0432\u0435\u0440\u043D\u0430\u044F \u0435\u0434\u0438\u043D\u0438\u0446\u0430 \u0438\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u044F " + this.current);
      }

      let timeSpanUnit = '';

      while (Char.isLetter(this.current)) {
        timeSpanUnit += this.current;
        this.nextSymbol();
      }

      let time = 0;

      switch (timeSpanUnit) {
        case 'ms':
          time = number;
          break;

        case 's':
          time = Time.sToMs(number);
          break;

        case 'm':
          time = Time.mToMs(number);
          break;

        case 'h':
          time = Time.hToMs(number);
          break;

        case 'd':
          time = Time.dToMs(number);
          break;

        case 'mth':
          time = Time.mthToMs(number);
          break;

        case 'y':
          time = Time.yToMs(number);
          break;

        default:
          this.Error("\u041D\u0435\u0432\u0435\u0440\u043D\u0430\u044F \u0435\u0434\u0438\u043D\u0438\u0446\u0430 \u0438\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u044F \u0434\u043B\u044F timespan: " + timeSpanUnit);
      }

      return this.createToken(TokenType.TimeSpan, time);
    }
  }, {
    key: "isEndOfString",
    value: function isEndOfString() {
      return this.tokens.length > 0 && this.tokens[this.tokens.length - 1].type === TokenType.EndOfString;
    }
  }, {
    key: "Error",
    value: function Error(description) {
      throw new ExpressionTokenizerError(description, {
        start: this.start,
        end: this.start
      });
    }
  }]);

  return ExpressionTokenizer;
}();

let ConditionVisitor = /*#__PURE__*/function (_ExpressionVisitor) {
  _inherits(ConditionVisitor, _ExpressionVisitor);

  var _super = /*#__PURE__*/_createSuper(ConditionVisitor);

  function ConditionVisitor() {
    _classCallCheck(this, ConditionVisitor);

    return _super.apply(this, arguments);
  }

  _createClass(ConditionVisitor, [{
    key: "visitBoolOpNode",
    value: function visitBoolOpNode(node) {
      _get(_getPrototypeOf(ConditionVisitor.prototype), "visitBoolOpNode", this).call(this, node);

      const leftExpression = node.left && node.left.accept(this);
      const rightExpression = node.right && node.right.accept(this);

      if (node.left instanceof BoolOperationNode && node.right instanceof BoolOperationNode) {
        this.checkBoolOperations(node.token.type, [...leftExpression.boolOperations, ...rightExpression.boolOperations]);
        return {
          boolOperations: [...leftExpression.boolOperations, node.token.type, ...rightExpression.boolOperations],
          expressions: [...leftExpression.expressions, ...rightExpression.expressions]
        };
      }

      if (node.right instanceof BoolOperationNode) {
        this.checkBoolOperations(node.token.type, rightExpression.boolOperations);
        return {
          boolOperations: [node.token.type, ...rightExpression.boolOperations],
          expressions: [leftExpression, ...rightExpression.expressions]
        };
      }

      if (node.left instanceof BoolOperationNode) {
        this.checkBoolOperations(node.token.type, leftExpression.boolOperations);
        return {
          boolOperations: [...leftExpression.boolOperations, node.token.type],
          expressions: [...leftExpression.expressions, rightExpression]
        };
      }

      return {
        boolOperations: [node.token.type],
        expressions: [leftExpression, rightExpression]
      };
    }
  }, {
    key: "visitOpNode",
    value: function visitOpNode(node) {
      var _node$right;

      _get(_getPrototypeOf(ConditionVisitor.prototype), "visitOpNode", this).call(this, node);

      this.checkExpressionSimple(node);
      const attribute = node.left && node.left.accept(this);
      const value = node.right && ((_node$right = node.right) == null ? void 0 : _node$right.accept(this));
      const operation = node.token.type;
      return {
        attribute,
        operation,
        value
      };
    }
  }, {
    key: "visitValueNode",
    value: function visitValueNode(node) {
      _get(_getPrototypeOf(ConditionVisitor.prototype), "visitValueNode", this).call(this, node);

      return node.token.value;
    }
  }, {
    key: "visitAttributeNode",
    value: function visitAttributeNode(node) {
      _get(_getPrototypeOf(ConditionVisitor.prototype), "visitAttributeNode", this).call(this, node);

      return node.token.value;
    }
  }, {
    key: "checkBoolOperations",
    value: function checkBoolOperations(baseOperation, operations) {
      if (operations.some(op => op !== baseOperation)) {
        throw new LintError('Выражение должно использовать одинаковые булевы операторы');
      }
    }
  }, {
    key: "checkExpressionSimple",
    value: function checkExpressionSimple(node) {
      if (!(node.left instanceof AttributeNode) || !(node.right instanceof ValueNode)) {
        if (!(node.right instanceof ValueNode)) throw new LintError('Выражение должно быть простым');
      }
    }
  }]);

  return ConditionVisitor;
}(ExpressionVisitor);

const isBoolResult = result => isObject(result) && 'boolOperations' in result;
const isExpression = result => isObject(result) && 'attribute' in result;
let ConditionInterpreter = /*#__PURE__*/function () {
  function ConditionInterpreter(condition) {
    _classCallCheck(this, ConditionInterpreter);

    this.result = null;
    this.tokenizer = new ExpressionTokenizer(condition);
  } // @ts-ignore TODO


  _createClass(ConditionInterpreter, [{
    key: "value",
    get: function get() {
      if (this.result) {
        return this.result;
      }

      try {
        const tokens = this.tokenizer.tokenize();
        const ast = new ExpressionAst(tokens).value;
        const result = ast && ast.accept(new ConditionVisitor());

        if (isBoolResult(result)) {
          this.result = result;
        } else if (isExpression(result)) {
          this.result = {
            boolOperations: [],
            expressions: [result]
          };
        } else {
          this.result = {
            boolOperations: [],
            expressions: []
          };
        }

        return this.result;
      } catch (e) {
        return e;
      }
    }
  }]);

  return ConditionInterpreter;
}();

let ConditionEvaluator = /*#__PURE__*/function () {
  function ConditionEvaluator(attributes) {
    _classCallCheck(this, ConditionEvaluator);

    this.attributes = attributes;
  }

  _createClass(ConditionEvaluator, [{
    key: "evaluate",
    value: function evaluate(condition, options) {
      try {
        const tokens = new ExpressionTokenizer(condition).tokenize();
        const ast = new ExpressionAst(tokens).value;
        return ast && ast.accept(new EvaluateVisitor(this.attributes, options));
      } catch (e) {
        return e;
      }
    }
  }]);

  return ConditionEvaluator;
}();

let ConditionLinter = /*#__PURE__*/function () {
  function ConditionLinter(attributes) {
    _classCallCheck(this, ConditionLinter);

    this.attributes = attributes;
  }

  _createClass(ConditionLinter, [{
    key: "lint",
    value: function lint(condition) {
      try {
        const tokens = new ExpressionTokenizer(condition).tokenize();
        const ast = new ExpressionAst(tokens).value;
        ast && ast.accept(new LintVisitor(this.attributes));
        return null;
      } catch (e) {
        return e;
      }
    }
  }]);

  return ConditionLinter;
}();

export { ArcCos, ArcSin, ArcTan, ArcTan2, AttributeNode, BoolOperationNode, Char, ConditionEvaluator, ConditionInterpreter, ConditionLinter, ConditionVisitor, Cos, DEFAULT_TOKEN_POSITION, EqlFunction, EqlFunctions, EvaluateVisitor, ExpressionAst, ExpressionAstError, ExpressionNode, ExpressionTokenizer, ExpressionTokenizerError, ExpressionVisitor, FunctionNode, LintError, LintVisitor, OperationNode, Sin, Sqrt, Tan, Time, Token, TokenError, TokenType, ValueNode, isBoolResult, isExpression, isObject };
//# sourceMappingURL=condition.esm.js.map
